import { render, staticRenderFns } from "./preheader.vue?vue&type=template&id=31d9122e&scoped=true"
import script from "./preheader.vue?vue&type=script&lang=js"
export * from "./preheader.vue?vue&type=script&lang=js"
import style0 from "./preheader.vue?vue&type=style&index=0&id=31d9122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9122e",
  null
  
)

export default component.exports